<template>
  <section class="field">
    <div v-if="hasAcvExceededProposedCost && !hasExceedPpaProposedCostAccess">
      <div class="notification is-warning is-flex">
        <i class="fas fa-exclamation-triangle is-warning fa-2x"></i>
        <div class="ml-10">
          <div v-if="showProposedCostExceedBy" class="block">
            <p><strong>{{ selectedLeaseInventory.exceedProposedCostByName }}</strong> set the ACV/Purchase Cost to <strong>{{ initialPurchaseCost | currency }}</strong></p><p>This exceeds PPA approved purchase cost of <strong>{{ cloneSourceProposedCost | currency}}</strong></p>
          </div>
          <div v-else-if="!hasInitialPurchaseCostChanged" class="block">
            <p>An individual set the ACV/Purchase Cost to <strong>{{ initialPurchaseCost | currency }}</strong></p><p>This exceeds PPA approved purchase cost of <strong>{{ cloneSourceProposedCost | currency}}</strong></p>
          </div>
          <div v-if="hasInitialPurchaseCostChanged && hasCurrentPurchaseCostExceededProposed" class="block">
            <strong>You dont have the required permission to override the limit of the approved ACV/Purchase Cost. </strong>
          </div>
        </div>
      </div>
    </div>

    <div v-if="hasAcvExceededProposedCost && hasExceedPpaProposedCostAccess">
      <div class="notification is-warning is-flex">
        <i class="fas fa-exclamation-triangle is-warning fa-2x"></i>
        <div class="ml-10">
          <div v-if="showProposedCostExceedBy" class="block"><p><strong>{{ derivedExceedByName }}</strong> set the ACV/Purchase Cost to <strong>{{ selectedLeaseInventory.purchaseCost | currency }}</strong></p><p>This exceeds PPA approved purchase cost of <strong>{{ cloneSourceProposedCost | currency}}</strong></p></div>
        </div>
      </div>
    </div>

    <div v-if="showPurchaseCostAcceptConditions" class="proposed-purchase-cost-diff box has-background-grey-lighter mt-5">
      <h4 class="title is-size-7 has-text-danger">
        The PURCHASE COST above ({{ purchaseCost | currency }}) is <u>NOT</u> the same as the approved ACV/PURCHASE COST in the ppa
      </h4>
      <h4 class="title is-size-7">
        <span v-if="isTrade">PPA Approved ACV: {{ displaySourceProposedCost | currency }}</span> 
        <span v-else>PPA Approved proposed cost: {{ displaySourceProposedCost | currency }}</span> <br/>
        <span v-if="isTrade">PPA Approved Trade Allowance: {{ displaySourceTradeAllowance | currency }}</span>  <br/>
        Approved by: {{ selectedLeaseInventory.cloneSourcePpaApprovedByName }}
      </h4>
      <h4 class="title is-size-7">Please Note: By activating the switch below you acknowledge the above vehicle's current status and accept responsibility for overriding the approved purchase cost</h4>
      <div class="is-flex">
        <b-switch type="is-info" v-model="purchaseCostAcceptConditions"></b-switch>
        <h4 v-if="purchaseCostAcceptConditions" class="title is-size-7 mt-5">I ACCEPT the above statement</h4>
        <h4 v-if="!purchaseCostAcceptConditions" class="title is-size-7 mt-5">I DO NOT ACCEPT the above statement <span class="has-text-danger">(SAVE BLOCKED until terms accepted)</span></h4>
      </div>
    </div>
  </section>
</template>

<script>

import SwitchSelector from '@/components/generic/SwitchSelector'
import utilitiesMixin from '@/mixins/generic/utilities'
import { createNamespacedHelpers } from 'vuex'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters
const mapUserGetters = createNamespacedHelpers('user').mapGetters

export default {
  name: 'ApprovedCostOverrideControl',
  mixins: [utilitiesMixin],
  components: {
    'switch-selector': SwitchSelector
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    blockSaveDueToPurchaseCostOverrideLocal: {
      type: Boolean,
      default: false
    },
    isConverting: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue: this.value, 
      purchaseCostAcceptConditions: false
    }
  },
  computed: {
    ...mapUserGetters(['currentUser', 'hasFeatureAccess']),
    ...mapConfigGetters(['definedTypes']),
    isPpaConverted () {
      return this.selectedLeaseInventory && this.selectedLeaseInventory.isPpaConverted
    },
    isTrade: function () {
      return this.selectedLeaseInventory && (this.selectedLeaseInventory.type === 'TradeIn' || this.selectedLeaseInventory.ppaIntention === 'Trade')
    },
    purchasedCostLimit () {
      if (!this.selectedLeaseInventory) return 0
      
      if (!this.isPpaConverted || this.hasExceedPpaProposedCostAccess) return 99999999.99
      
      if (!this.hasExceedPpaProposedCostAccess && this.isPpaConverted) {
        if (this.selectedLeaseInventory.purchaseCost > this.cloneSourceProposedCost && this.showProposedCostExceedBy) {
          return this.initialPurchaseCost !== this.selectedLeaseInventory.purchaseCost ? this.cloneSourceProposedCost : this.initialPurchaseCost
        }
      }

      return this.cloneSourceProposedCost
    },
    purchasedCostMin () {
      if (!this.hasExceedPpaProposedCostAccess && this.isPpaConverted) {
        if (this.selectedLeaseInventory.purchaseCost < this.cloneSourceProposedCost) {
          return 0
        }

        if (this.selectedLeaseInventory.purchaseCost > this.cloneSourceProposedCost && this.showProposedCostExceedBy) {
          return this.initialPurchaseCost !== this.selectedLeaseInventory.purchaseCost ? this.cloneSourceProposedCost : this.initialPurchaseCost
        }
      }
      return 0
    },
    hasExceedPpaProposedCostAccess () {
      return this.hasFeatureAccess('inventory.modify.exceed-ppa-proposed-cost', false)
    },
    hasAcvExceededProposedCost: function () {
      if (this.hasExceedPpaProposedCostAccess) {
        return this.selectedLeaseInventory.purchaseCost > this.cloneSourceProposedCost
      }
      // return this.initialPurchaseCost > this.cloneSourceProposedCost

      if (!this.hasExceedPpaProposedCostAccess && this.hasInitialPurchaseCostChanged) {
        return this.selectedLeaseInventory.purchaseCost > this.cloneSourceProposedCost || this.initialPurchaseCost > this.cloneSourceProposedCost
      }

      return this.initialPurchaseCost > this.cloneSourceProposedCost
    },
    cloneSourceProposedCost: function () {
      if (this.isConverting) return this.initialPurchaseCost
      if (this.selectedLeaseInventory.cloneSourceInventoryId > 0 && this.selectedLeaseInventory.cloneSourceProposedCost > 0) {
        return this.selectedLeaseInventory.cloneSourceProposedCost
      }
      return 99999999.99
    },
    displaySourceProposedCost: function () {
      if (this.isConverting) return this.initialPurchaseCost
      if (this.selectedLeaseInventory.cloneSourceInventoryId > 0 && this.selectedLeaseInventory.cloneSourceProposedCost > 0) {
        return this.selectedLeaseInventory.cloneSourceProposedCost
      }
      return 0
    },
    displaySourceTradeAllowance: function () {
      if (this.selectedLeaseInventory && this.selectedLeaseInventory.tradeAllowance > 0) {
        return this.selectedLeaseInventory.tradeAllowance
      }
      return 0
    },
    showProposedCostExceedBy: function () {
      if (!this.hasExceedPpaProposedCostAccess) {
        return this.selectedLeaseInventory.isProposedCostExceededApproved &&
          this.selectedLeaseInventory.exceedProposedCostByName !== '' &&
          this.selectedLeaseInventory.exceedProposedCostByName !== null
      }

      return this.selectedLeaseInventory.purchaseCost > this.cloneSourceProposedCost
    },
    derivedExceedByName: function () {
      if (!this.hasInitialPurchaseCostChanged) {
        return this.selectedLeaseInventory && this.selectedLeaseInventory.exceedProposedCostByName ? this.selectedLeaseInventory.exceedProposedCostByName : 'An individual'
      }
      return this.selectedLeaseInventory && this.selectedLeaseInventory.exceedProposedCostByName ? this.selectedLeaseInventory.exceedProposedCostByName : 'You'
    },
    hasInitialPurchaseCostChanged: function () {
      return this.selectedLeaseInventory.purchaseCost !== this.initialPurchaseCost
    },
    hasCurrentPurchaseCostExceededProposed: function () {
      return this.selectedLeaseInventory.purchaseCost > this.cloneSourceProposedCost
    },
    isDifferenceInCostsPPA: function () {
      if (!this.selectedLeaseInventory) return false

      if (this.selectedLeaseInventory.purchaseCost === null || !this.isPpaConverted) {
        return false
      }
      return (this.initialPurchaseCost !== this.selectedLeaseInventory.purchaseCost) && (this.selectedLeaseInventory.purchaseCost !== this.cloneSourceProposedCost)
    },
    showPurchaseCostAcceptConditions: function () {
      if (this.isDifferenceInCostsPPA && this.hasAcvExceededProposedCost && this.hasExceedPpaProposedCostAccess) {
        return true
      }

      if (this.isDifferenceInCostsPPA && !this.hasAcvExceededProposedCost) {
        return true
      }

      if (this.isDifferenceInCostsPPA && !this.hasCurrentPurchaseCostExceededProposed) {
        return true
      }

      return false
    },
    selectedLeaseInventory: function () {
      if (!this.localValue || !this.localValue.forInventory) return null
      return this.localValue.forInventory
    },
    initialPurchaseCost: function () {
      return this.localValue && this.localValue.initialPurchaseCost ? this.localValue.initialPurchaseCost : 0
    },
    purchaseCost: function () {
      return this.localValue && this.selectedLeaseInventory && this.selectedLeaseInventory.purchaseCost ? this.selectedLeaseInventory.purchaseCost : 0 
    },
    showApprovedInfo: function () {
      return !this.isConverting
    }
  },
  methods: {
  },
  watch: {
    value: function (newValue, oldValue) {
      if (newValue && oldValue) {
        this.localValue = newValue
      }
    },
    purchaseCostAcceptConditions: function (newValue, oldValue) {
      if (newValue === true && this.isDifferenceInCostsPPA) {
        this.$emit('update:blockSaveDueToPurchaseCostOverrideLocal', false)
      }

      if (newValue === false && this.isDifferenceInCostsPPA) {
        this.$emit('update:blockSaveDueToPurchaseCostOverrideLocal', true)
      }
    },
    isDifferenceInCostsPPA: function (newValue, oldValue) {
      if (newValue === true) {
        this.$emit('update:blockSaveDueToPurchaseCostOverrideLocal', true)
      }

      if (newValue === false) {
        this.$emit('update:blockSaveDueToPurchaseCostOverrideLocal', false)
        this.purchaseCostAcceptConditions = false
      }
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>

<style scoped>
  
</style>
